import {useQuery} from "@tanstack/react-query";
import {getList} from "../../../app/getters/getList.js";
import {getData} from "../../../app/getters/getData.js";
import {useSelector} from "react-redux";

export const useListaSprawozdan = (rejestrId, enabled = true) => {
    const rola = useSelector((state) => state.user.role);
    const roleParam = rola === 'oper' ? 'oper/' : '';

    return useQuery({
        queryKey: [`lista_sprawozdan`, rejestrId],
        queryFn: () => getData(`/${roleParam}sprawozdanie/lista/${rejestrId}`),
        enabled: enabled && !!rejestrId
    })
}

export const fetchListaSprawozdan = async (rejestrId, rola) => {
    const roleParam = rola === 'oper' ? 'oper/' : '';
    const list = await getList(`/${roleParam}sprawozdanie/lista/${rejestrId}`);
    return list || [];
}
